<template>
    <Modal
      v-model="isLoginModalActive"
      :whiteCross="'text-white'"
      title="Sign In"
      :handleClose="closeLoginModalHandler"
    >
        <div class="flex flex-col items-center py-4">
            <button
              type="button"
              class="h-10 w-48 px-6 py-2 text-sm font-medium tracking-wide
              capitalize text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:bg-green-light"
              @click="authHandler('login')"
            > Log In
            </button>
            <h4 class="py-4">- OR -</h4>
            <button
              type="button"
              class="h-10 w-48 px-6 py-2 text-sm font-medium tracking-wide capitalize text-white transition-colors
              duration-150 bg-green-light rounded-lg focus:outline-none hover:bg-green-light"
              @click="authHandler('signup')"
            > 
              Sign Up 
            </button>
        </div>
    </Modal>
</template>
<script>
import { Modal } from "@/components/t-components";
export default {
    props: [
        'isLoginModalActive'
    ],
    components: {
        Modal
    },
    methods: {
        authHandler (authMethod) {
          this.$store.commit('setAuthModalActive', false)
          authMethod && authMethod === 'login' ? this.$router.push(`/login?redirect=${this.$route.fullPath}`) : this.$router.push('/sign-up')
        },
        closeLoginModalHandler () {
          this.$store.commit('setAuthModalActive', false)
        }
    }
}
</script>